import { api } from '@/api/api-client.config';
import { useQuery } from '@tanstack/react-query';
import { UserType } from '@/@types/api.types';

const getPickemParticipants = (id: number): Promise<{ users: UserType[] }> =>
  api.get(`/admin/pickems/${id}/users`);

export const useGetPickemParticipantsQuery = (id: number) => {
  return useQuery({
    queryKey: ['getPickemParticipants', id],
    queryFn: () => getPickemParticipants(id),
    select: (data) => data.users,
  });
};
